import React from 'react'
import { FormattedMessage } from 'react-intl';

import {
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';

import {
  onEnter,
  onExit
} from "../../../../../../config/customModalFunctions";
import { CreateUserForm } from "./forms/CreateUser";
import * as usersApi from '../../../../../../api/admin/users'
import { NOTIFICATION_CREATE_ADMIN_USER } from '../../../../../../config/notifications';

const CreateUserModal = ({ showModal, closeModal, actionCallback }) => {

  const submit = (values) => {
    let payload = {
      notificationId: values.action === 'add' ? NOTIFICATION_CREATE_ADMIN_USER : null,
      data: {
        email: values.email,
        first_name: values.firstName,
        last_name: values.lastName
      }
    }

    return usersApi.createAdminUser( payload ).then( data => {
      if (data.data.id) {
        actionCallback(1);
        return true;
      }

      return false;

    } ).finally( () => {
      if (values.action === 'save') {
        closeModal();
      }

      return false;
    } );
  }

  return (
    <Modal
      isOpen={showModal}
      toggle={closeModal}
      onEnter={onEnter}
      onExit={onExit}

      centered
    >
      <ModalHeader
        toggle={closeModal}
      >
        <FormattedMessage
          id="components.pages.admin.users.modals.create.title"/>
      </ModalHeader>
      <ModalBody>
        <CreateUserForm
          toggle={closeModal}
          submit={submit}
        />
      </ModalBody>
    </Modal>
  )
}

export {
  CreateUserModal
}
